import { render, staticRenderFns } from "./NvrDeviceMg.vue?vue&type=template&id=701ee1f1&scoped=true&"
import script from "./NvrDeviceMg.vue?vue&type=script&lang=js&"
export * from "./NvrDeviceMg.vue?vue&type=script&lang=js&"
import style0 from "./NvrDeviceMg.vue?vue&type=style&index=0&id=701ee1f1&prod&lang=scss&scoped=true&"
import style1 from "./NvrDeviceMg.vue?vue&type=style&index=1&id=701ee1f1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701ee1f1",
  null
  
)

export default component.exports